module.exports = __webpack_public_path__ + "img/pen.3f72d229.svg";